export default __webpack_public_path__ + "static/media/Background_00159.56cb5dfa.png";